import { Component, OnInit, Input,  ChangeDetectorRef, SimpleChanges, DestroyRef, inject, signal } from '@angular/core';
import { AcvisService } from '../../services/acvis.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { RegionItem } from '@app/models/compass/RegionItem';
import { PassolutionService } from '@app/services/passolution.service';
import moment from 'moment';
import { CommonModule, formatNumber } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReisecompassModule } from '../reisecompass/reisecompass.module';
import { PipeModule } from '@app/pipe/pipe.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { DirectiveModule } from '@app/directives/directive.module';
import { filter, take } from 'rxjs/operators';

export interface CoronapasFilter {
    entry: {
        possible: boolean,
        partial: boolean,
        closed: boolean,
        air: boolean,
        sea: boolean,
        land: boolean,
    },
    onentry: any,
    atdestination: {
        hotels: boolean,
        restaurants: boolean,
        bars: boolean,
        assemblies: boolean,
        clubs: boolean,
        museums_sights: boolean,
        beaches: boolean,
        public_transport: boolean,
        public_life: boolean,
        public_life_restricted?: boolean,
        mouth_nose_protection: boolean,
    },
    nowarning: boolean,
    quarantine_on_entry: boolean,
    quarinfoopen: boolean;
    quarinfo: any;
};
@Component({
    selector: 'app-coronatravelinfo',
    templateUrl: './coronatravelinfo.component.html',
    styleUrls: ['./coronatravelinfo.component.scss'],
    imports: [
        CommonModule,
        MatIconModule,
        MatDividerModule,
        PipeModule,
        DirectiveModule,
        ReisecompassModule
    ]
})
export class CoronatravelinfoComponent implements OnInit {
    @Input() countrycode: any;
    @Input() contentid: any;
    country: string;
    currentRegionData: RegionItem;
    loading: boolean = false;
    charts: any;
    passolution = signal<any>(null);
    passolutionLoading = signal<boolean>(false);
    countryupdate: any;
    chartOption: any = {};
    deskmode: string = 'xl';
    open: boolean = false;
    destroyRef = inject(DestroyRef);
    constructor(
        protected cdr: ChangeDetectorRef,
        protected mediaObserver: BreakpointObserver,
        protected acvisService: AcvisService,
        protected guardService: AuthGuardService,
        protected passServie: PassolutionService
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['countrycode']) {
            this.countrycode = changes['countrycode'].currentValue;
            this.passolution.set(null);
            this.passolutionLoading.set(false);
            if (this.countrycode) {
                this.getwarningcontentLander();
                if (this.open) {
                    this.getcountryfromNat(this.countrycode);
                }
            }
        }
    }

    ngOnInit(): void {
        this.initMedia();
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.deskmode = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.deskmode = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.deskmode = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.deskmode = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.deskmode = 'xl';
        }
        this.cdr.detectChanges();
    }

    async getcountryfromNat(countrycode) {
        if (this.passolution() || this.passolutionLoading()) {
            return;
        }
        this.passolutionLoading.set(true);
        this.guardService.getPartner$.pipe(
            filter(partner => !!partner),
            take(1),
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            if (partner) {
                const target = {
                    lang: 'de',
                    nat: 'de',
                    countries: countrycode,
                    order: 'tagdate',
                    sort: 'desc',
                    limit: 10,
                    page: 1,
                    passolutionusername: partner.passolutionusername,
                    passolutionpassword: partner.passolutionpassword,
                };
                this.passolution.set(null);
                this.passServie.request(target, 'getcountryfromNat').pipe(
                    takeUntilDestroyed(this.destroyRef)
                ).subscribe(res => {
                    this.passolution.set(res.passolution?.[0]);
                    this.passolutionLoading.set(false);
                }, () => {
                    this.passolutionLoading.set(false);
                });
            }
        });
    }

    async initCharts(data) {
        if (data.statx?.length > 0 && data.staty?.length > 0) {
            this.chartOption = {
                tooltip: {
                    trigger: 'axis',
                    formatter: (params) => {
                        return 'Datum: ' + moment(params[0].axisValue).format('DD.MM.YYYY') + '<br>Inzidenz (7 Tage): ' + formatNumber(params[0].data, 'de-DE', '1.2-2');
                    },
                    hover: {
                        animationDuration: 0
                    }
                },
                xAxis: {
                    data: data.statx,
                    axisLabel: {
                        formatter: (params) => {
                            return moment(params).format('DD.MM.YYYY');
                        },
                        show: true,
                        fontSize: '9'
                    },
                },
                yAxis: {
                    axisLabel: {
                        show: true,
                        fontSize: '7'
                    },
                },
                grid: {
                    top: 10,
                    left: 30,
                    right: 30,
                    bootom: 10,
                    width: 'auto',
                    height: 'auto'
                },
                series: [{
                    data: data.staty,
                    type: 'line',
                    smooth: true,
                    showSymbol: false,
                    lineStyle: { color: '#545454' },
                    animationDelay: (idx) => idx * 10 + 100,
                }],
                animationEasing: 'elasticOut',
                animationDelayUpdate: (idx) => idx * 5,
            };
            this.cdr.detectChanges();
        }
    }

    scrollToTop() {
        this.open = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    toggleOpen(): void {
        this.open = !this.open;
        if (this.open && this.countrycode?.length > 0) {
            this.getcountryfromNat(this.countrycode);
        }
    }

    async getwarningcontentLander() {
        this.loading = true;
        this.cdr.detectChanges();
        if (this.countrycode?.length > 0) {
            const target = {
                code: this.countrycode
            };
            this.acvisService.request(target, 'getcoronatravelinfos').pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(res => {
                if (res && !res.error && res?.length > 0) {
                    this.currentRegionData = {} as RegionItem;
                    this.currentRegionData.title = res[0].travelwarning?.title;
                    this.country = res[0].travelwarning?.country;
                    this.currentRegionData.content = res[0].travelwarning?.content?.replace(/<button/ig, '<button style="display:none" ')
                        .replace(/<h4/ig, '<h4 style="margin: 1rem 0 0 0;font-weight: 600;" ')
                        .replace(/<h3/ig, '<h3 style="margin: 1rem 0 0 0;font-weight: 600;" ')
                        .replace(/<h2/ig, '<h2 style="margin: 1rem 0 0 0;font-weight: 600;" ')
                        .replace(/<a /ig, '<a class="linkified" target="_blank" ');
                    this.currentRegionData.flagUrl = res[0].travelwarning?.flagUrl;

                    const quarantine = !isNaN(Number(res[0].quarantine_on_entry?.quarantine_for_days)) ? Number(res[0].quarantine_on_entry?.quarantine_for_days) : 0;
                    this.currentRegionData.entry = {
                        possible: res[0].entry?.status === 'allowed',
                        partial: res[0].entry?.status === 'partial',
                        closed: res[0].entry?.status === 'closed',
                        air: !(res[0].closed_borders?.air),
                        sea: !(res[0].closed_borders?.sea_border_ports),
                        land: !(res[0].closed_borders?.land_borders)
                    };
                    this.currentRegionData.quarantine_on_entry = quarantine > 0;
                    this.currentRegionData.quarinfo = res[0].quarantine_on_entry?.additional_content;
                    this.currentRegionData.onentry = {
                        show_covid_19_test_info: res[0].important_when_entering_the_country?.show_covid_19_test?.additional_content,
                        show_covid_19_test: (res[0].important_when_entering_the_country?.show_covid_19_test?.required === 'yes' || res[0].important_when_entering_the_country?.show_covid_19_test?.required === true),
                        registration: (res[0].important_when_entering_the_country?.registration?.required === 'yes' || res[0].important_when_entering_the_country?.registration?.required === true),
                        registration_info: res[0].important_when_entering_the_country?.registration?.additional_content,
                        quick_test_obligatory_on_site: (res[0].important_when_entering_the_country?.quick_test_obligatory_on_site?.required === 'yes' || res[0].important_when_entering_the_country?.quick_test_obligatory_on_site?.required === true),
                        quick_test_obligatory_on_site_info: res[0].important_when_entering_the_country?.quick_test_obligatory_on_site?.additional_content,
                        obligation_to_download_corona_app: (res[0].important_when_entering_the_country?.obligation_to_download_corona_app?.required === 'yes' || res[0].important_when_entering_the_country?.obligation_to_download_corona_app?.required === true),
                        obligation_to_download_corona_app_info: res[0].important_when_entering_the_country?.obligation_to_download_corona_app?.additional_content
                    };
                    this.currentRegionData.atdestination = {
                        mouth_nose_protection: (res[0].important_at_the_destination?.mouth_nose_protection?.required === 'yes' || res[0].important_at_the_destination?.mouth_nose_protection?.required === 'partially' || res[0].important_at_the_destination?.mouth_nose_protection?.required === true),
                        bars: res[0].important_at_the_destination?.bars?.status === 'allowed',
                        clubs: res[0].important_at_the_destination?.clubs?.status === 'allowed',
                        beaches: res[0].important_at_the_destination?.beaches?.status === 'allowed',
                        assemblies: res[0].important_at_the_destination?.assemblies?.status === 'allowed',
                        hotels: res[0].important_at_the_destination?.hotels?.status === 'allowed',
                        restaurants: res[0].important_at_the_destination?.restaurants?.status === 'allowed',
                        public_life: res[0].important_at_the_destination?.public_life?.status === 'allowed',
                        museums_sights: res[0].important_at_the_destination?.museums_sights?.status === 'allowed',
                        public_transport: res[0].important_at_the_destination?.public_transport?.status === 'allowed'
                    };

                    this.currentRegionData.statusrki = res[0].statusrki;
                    this.currentRegionData.ampelauto = res[0].ampelauto;
                    this.currentRegionData.ampelcolor = res[0].ampelcolor;

                    if (this.currentRegionData.statusrki?.code !== 0 && this.currentRegionData.statusrki?.code !== 2 && this.currentRegionData.statusrki?.code !== 3 && res[0].travel_advisory?.status?.length > 0) {
                        if (res[0].travel_advisory?.additional_content?.length > 0) {
                            this.currentRegionData.statusrkiinfo = res[0].travel_advisory?.additional_content[0].content;
                        }
                        switch (res[0].travel_advisory.status) {
                            case 'virus_variant_area':
                                this.currentRegionData.statusrki = {
                                    code: 3,
                                    name: 'Virusvariantengebiet'
                                };
                                break;
                            case 'high_risk_region':
                                this.currentRegionData.statusrki = {
                                    code: 2,
                                    name: 'Hochrisikogebiet'
                                };
                                break;

                            default:
                                this.currentRegionData.statusrki = {
                                    code: 0,
                                    name: 'sonstige Gebiete'
                                };
                                break;
                        }
                    } else {
                        this.currentRegionData.statusrki.code = Number(this.currentRegionData.statusrki.code);
                    }

                    switch (this.currentRegionData.statusrki?.name) {
                        case 'Hochinzidenzgebiet':
                        case 'Hochrisikogebiet':
                            this.currentRegionData.statusskicolor = 'red';
                            break;
                        case 'Virusvariantengebiet':
                            this.currentRegionData.statusskicolor = 'red';
                            break;

                        default:
                            this.currentRegionData.statusskicolor = 'green';
                            break;
                    }

                    this.currentRegionData.inzidenzcolor = res[0].coronav2?.color;
                    this.currentRegionData.inzidenzauto = true;
                    this.currentRegionData.inzidenzLand = res[0].coronav2?.seven_day_rate;
                    this.currentRegionData.coronav2_seven_day_history = res[0].coronav2?.seven_day_history?.slice(-30);

                    this.charts = { statx: [], staty: [] };
                    for (let i = 0; i < this.currentRegionData.coronav2_seven_day_history?.length; i++) {
                        this.charts.statx.push(this.currentRegionData.coronav2_seven_day_history[i].date);
                        this.charts.staty.push(this.currentRegionData.coronav2_seven_day_history[i].value);
                    }

                    const tmpavg = this.charts?.staty.slice(-7);
                    let prctab = 0;
                    for (let i = 0; i < tmpavg.length - 1; i++) {
                        prctab += (tmpavg[i + 1] - tmpavg[i]) * 100 / tmpavg[i];
                    }
                    let w4 = 0;
                    if (tmpavg.length > 0 && tmpavg[0] > 0) {
                        const prc = prctab / tmpavg.length;
                        const last = tmpavg[tmpavg.length - 1];
                        const w1 = last + ((last * prc) / 100);
                        const w2 = w1 + (w1 * prc / 100);
                        const w3 = w2 + (w2 * prc / 100);
                        w4 = w3 + (w3 * prc / 100);
                    }
                    if (this.currentRegionData.ampelauto !== false) {
                        if (w4 < 200) {
                            this.currentRegionData.ampelcolor = 'green';
                        } else if (w4 < 350) {
                            this.currentRegionData.ampelcolor = 'orange';
                        } else if (w4 >= 350) {
                            this.currentRegionData.ampelcolor = 'red';
                        }
                    }
                    this.initCharts(this.charts);
                    this.currentRegionData.nowarning = !(res[0].warning || res[0].situationWarning);
                }
                this.loading = false;
                this.cdr.detectChanges();
            });
        } else {
            this.currentRegionData = {} as RegionItem;
        }
    }

    async openLink(url) {
        if (url?.length > 0) {
            window.open(url, '_blank', 'noopener');
        }
    }
}
